// Credentials are checked only by the server; never bundle them into the site.
const AUTH_API = "./api/auth.php";
let csrf;
export async function readSession() {
  const response = await fetch(AUTH_API, { credentials: "same-origin", cache: "no-store" });
  if (!response.ok) throw new Error("לא ניתן לבדוק את ההתחברות. נסו שוב.");
  const session = await response.json();
  csrf = session.csrf;
  return session;
}
export async function sessionRequest(url, body) {
  if (!csrf) await readSession();
  const response = await fetch(url, {
    method: "POST", credentials: "same-origin",
    headers: { "Content-Type": "application/json", "X-CSRF-Token": csrf },
    body: JSON.stringify(body),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok || result.ok !== true) {
    if (response.status === 401 || response.status === 403) csrf = undefined;
    throw new Error(response.status === 401 ? "שם המשתמש או הסיסמה שגויים, או שההתחברות פגה." : "הפעולה נכשלה. נסו שוב מאוחר יותר.");
  }
  if (result.csrf) csrf = result.csrf;
  return result;
}
export function authenticate(user, pass) { return sessionRequest(AUTH_API, { user, pass }); }
export async function endSession() { await sessionRequest(AUTH_API, { action: "logout" }); csrf = undefined; }
